import { useRef, useState } from "react";
import { saveUtilityStateOperation } from "../utilityApi";

export default function useSopEditSave({ onSuccess, onRefresh, notify }) {
  const [saving, setSaving] = useState(false);
  const [canRefresh, setCanRefresh] = useState(false);
  const inFlight = useRef(false);
  const save = async (payload) => {
    if (inFlight.current || !payload.CommodityIds?.length) return;
    inFlight.current = true;
    setSaving(true);
    try {
      const result = await saveUtilityStateOperation({
        EnerexUtilityId: payload.EnerexUtilityId,
        EnerexStateId: payload.EnerexStateId,
        CommodityIds: [...payload.CommodityIds],
        ExpectedMappingIds: [...payload.ExpectedMappingIds],
        ServiceReferenceNumberRequired: Boolean(payload.ServiceReferenceNumberRequired),
        ServiceReferenceNumberDescription: payload.ServiceReferenceNumberDescription || null,
        KeyNameRequired: Boolean(payload.KeyNameRequired),
        KeyNameDescription: payload.KeyNameDescription ?? "",
        EnrollmentLeadTime: payload.EnrollmentLeadTime ?? "",
        ...(payload.StateIds && { StateIds: [...payload.StateIds] }),
        ...(payload.CommodityMappings && { CommodityMappings: payload.CommodityMappings.map((mapping) => ({ ...mapping })) }),
        ...(payload.UserName && { UserName: payload.UserName }),
      });
      const success = result?.isSuccess ?? result?.IsSuccess;
      if (success !== true && (!Array.isArray(result) || !result.length)) {
        throw new Error(result?.message || result?.Message || "State mappings were not saved.");
      }
      setCanRefresh(false);
      await onSuccess(result?.message || result?.Message || "State of operations updated successfully");
    } catch (error) {
      setCanRefresh(error.status === 409);
      notify(error.message || "Failed to update state mappings", "error");
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };
  const refresh = async () => {
    if (inFlight.current || !canRefresh) return;
    inFlight.current = true;
    setSaving(true);
    try {
      await onRefresh();
      setCanRefresh(false);
    } catch (error) {
      notify(error.message || "Failed to reload state mappings", "error");
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };
  return { saving, canRefresh, save, refresh, reset: () => setCanRefresh(false) };
}
